import { render, staticRenderFns } from "./fb-contry-map.vue?vue&type=template&id=dd1ae610&scoped=true"
import script from "./fb-contry-map.vue?vue&type=script&lang=js"
export * from "./fb-contry-map.vue?vue&type=script&lang=js"
import style0 from "./fb-contry-map.vue?vue&type=style&index=0&id=dd1ae610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1ae610",
  null
  
)

export default component.exports